export { default } from './Footer.container'



// WEBPACK FOOTER //
// ./src/components/Footer/index.js